export default __webpack_public_path__ + "static/media/favicon.c3bd6f3f.png";